/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb, Descriptions,Card, Space, Tag, Tooltip} from "antd";
import {ToolTwoTone} from "@ant-design/icons";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../store";
import {CustomButton} from "../components/buttons";
import {IconSet} from "../components/icons";
import {openDrawer} from "../reducers/drawers-reducer";
import {useEffect, useState} from "react";
import {ORMObject, Person, User} from "../core/datamodel";
import {ViewState} from "../states";
import {get} from "../core/request";

export default function SelfView(props: any) {
    const userInfo = useAppSelector(state => state.auth.userInfo);

    const person_id = userInfo ? userInfo['person_id'] : undefined
    const personReloadSignal = useAppSelector(state => state.reloadSignals.person)
    const [person, setPerson] = useState({} as Person);

    const user_id = userInfo ? userInfo['user_id'] : undefined
    const userReloadSignal = useAppSelector(state => state.reloadSignals.person)
    const [user, setUser] = useState({} as User);

    const [state, setState] = useState(ViewState.loading);

    useEffect(() => {
        get("users/" + user_id).done((response) => {
                setUser(new User(response.data.user));
                setState(ViewState.success);
            }
        ).fail(() => setState(ViewState.failed))
    }, [user_id, userReloadSignal])

    useEffect(() => {
        get("persons/" + person_id).done((response) => {
                setPerson(new Person(response.data.person));
                setState(ViewState.success);
            }
        ).fail(() => setState(ViewState.failed))
    }, [person_id, personReloadSignal])

    let dispatch = useAppDispatch();


    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Mein Account</Breadcrumb.Item>
            </Breadcrumb>

            <Card
                title="Mein Account"
                extra={
                    <Space>
                        <CustomButton
                            mode={'password'}
                            onClick={
                                () => dispatch(openDrawer({key: 'password', object: {} as ORMObject}))
                            }
                            tooltip={"Passwort ändern"}/>

                        <CustomButton
                            mode={'edit'}
                            onClick={
                                () => dispatch(openDrawer({key: 'person', object: person}))
                            }
                            tooltip={"Meinen Kontakt bearbeiten"}/>
                    </Space>}>

                <Descriptions colon={false} size="small">
                    <Descriptions.Item
                        label={
                            <Tooltip overlay={"Mein Kontakt"}>
                                <IconSet type='persons' style={{lineHeight: '24px', alignSelf: 'center'}}/>
                            </Tooltip>}
                        children={user?.props?.person ?
                            <Tooltip overlay={"Mein Kontakt"}>
                                <Link to={"/persons/" + user.props.person.props.uuid}>
                                    {user.props.person.props.repr}
                                </Link>
                            </Tooltip> : ""}
                    />

                    <Descriptions.Item children=""/>

                    <Descriptions.Item
                        label={
                            <Tooltip overlay={"Gruppen"}>
                                <IconSet type='groups' style={{lineHeight: '24px', alignSelf: 'center'}}/>
                            </Tooltip>}
                        children={
                            <Tooltip overlay={"Gruppen"}>
                                {
                                    user?.props?.groups?.map(group => <Tag children={group}/>)
                                }
                            </Tooltip>
                        }
                    />

                    <Descriptions.Item
                        label={
                            <Tooltip overlay={"E-Mail"}>
                                <IconSet type='mail' style={{lineHeight: '24px', alignSelf: 'center'}}/>
                            </Tooltip>}
                        children={
                            !!person?.props?.mail ?
                                (<a href={'Mailto:' + person.props.mail}>{person.props.mail}</a>) :
                                ("")
                        }
                    />

                    <Descriptions.Item
                        label={
                            <Tooltip overlay={"Telefonnummer"}>
                                <IconSet type='phone' style={{lineHeight: '24px', alignSelf: 'center'}}/>
                            </Tooltip>}
                        children={person?.props?.phone}
                    />

                    <Descriptions.Item
                        label={
                            <Tooltip overlay={"Mobilnummer"}>
                                <IconSet type='mobile' style={{lineHeight: '24px', alignSelf: 'center'}}/>
                            </Tooltip>}
                        children={person?.props?.mobile}
                    />
                </Descriptions>
            </Card>
        </>
    )
}